// Native autofocus only fires on the initial page load, so a control that LiveView mounts
// later, or that a library rebuilds, is focused once it is ready.
export const focusWhenReady = async (
  control: HTMLElement,
  ready: Promise<unknown> = Promise.resolve()
): Promise<void> => {
  await ready

  if (control.autofocus && control.isConnected) {
    control.focus()
  }
}
